export const voyage = {
  pelerinage: 'PELERINAGE___voyage',
  keyPelerinage: 'PELERINAGE_',
};
